<template>
  <form @submit.prevent="assignDriver()">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="assignDriverToBackupTRModalLabel">
          Assign Driver to "{{ backupTrip.backup_request_code }}"
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          ref="modalCloseBtn"
        ></button>
      </div>
      <div class="modal-body">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-6">
                <label for="">Driver Mobile: </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.mobile"
                  placeholder="Mobile"
                  required
                  maxlength="11"
                  pattern="[0-9]{11}"
                  title="11 digit length containing only numbers!"
                />
                <span class="text-warning" style="font-size: 13px"
                  >Mobile No. should must be 11 digits from 0.</span
                >
              </div>
              <div class="col-md-6">
                <label for="">Driver Name: </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="formValue.name"
                  placeholder="Name"
                  :readonly="
                    formValue.driver_code ||
                    (formValue.mobile && formValue.mobile.length < 11)
                  "
                  required
                />
              </div>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-sm-12">
            <div class="invite-backup-partner-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>BR Code</th>
                    <th>Route</th>
                    <th>Regular Price</th>
                    <th>Multiplier %</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ backupTrip.backup_request_code }}</td>
                    <td>{{ backupTrip.route_name }}</td>
                    <td>{{ formValue.price ? formValue.price : 'N/A' }}</td>
                    <td>
                      <input
                        type="number"
                        :disabled="
                          !backupTrip.trip_request_id || !formValue.price
                        "
                        :class="{
                          'form-control': true,
                          'danger-value': formValue.multiplier >= 20
                        }"
                        @keyup="calculateTotal()"
                        @change="calculateTotal()"
                        v-model="formValue.multiplier"
                        step="any"
                      />
                    </td>
                    <td>
                      <input
                        type="number"
                        :class="{
                          'form-control': true,
                          'danger-value': formValue.multiplier >= 20
                        }"
                        @keyup="calculateMultiplier()"
                        @change="calculateMultiplier()"
                        v-model="formValue.total"
                        step="any"
                        required
                      />
                    </td>
                  </tr>
                  <tr v-if="!backupTrip.trip_request_id">
                    <td colspan="20">
                      <p class="text-danger">
                        This trip doesn't have a trip id. So the bill can not be
                        calculated!
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button v-if="isLoading" class="btn btn-primary" type="button" disabled>
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
        <button v-else class="btn btn-primary">
          {{ formValue.driver_code ? '' : 'Create & ' }} Assign Driver
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import http from '../../config/axios';
import userService from '../../config/axiosUserService';
import { backupRequest } from '../../store/backupRequest/backupRequest';

export default {
  props: ['backupTrip'],
  data() {
    return {
      formValue: {
        id: null,
        trip_request_id: null,
        route_name: '',
        price: null,
        multiplier: null,
        total: null,
        driver_code: '',
        name: '',
        mobile: ''
      },
      isLoading: false,
      backupRequest
    };
  },
  watch: {
    backupTrip: {
      handler() {
        this.setFormValues();
        this.formValue.price = backupRequest.calculatePriceFromTripRequest(
          this.backupTrip.tripRequestRoute
            ? this.backupTrip.tripRequestRoute
            : this.backupTrip.tripRequest
        );
      },
      deep: true
    },
    'formValue.mobile': {
      handler() {
        this.searchDriverByPhone();
      },
      deep: true
    },
    'formValue.driver_code': {
      handler() {
        if (!this.formValue.driver_code) {
          this.formValue.name = '';
        }
      },
      deep: true
    }
  },
  methods: {
    setFormValues() {
      this.formValue = {
        id: this.backupTrip.id,
        trip_request_id: this.backupTrip.trip_request_id,
        route_name: this.backupTrip.route_name,
        price: null,
        multiplier: null,
        total: null,
        driver_code: '',
        name: '',
        mobile: ''
      };
    },
    calculateTotal() {
      if (this.formValue.multiplier && this.formValue.price) {
        this.formValue.total = (
          (this.formValue.multiplier * parseFloat(this.formValue.price)) / 100 +
          parseFloat(this.formValue.price)
        ).toFixed(4);
      } else {
        this.formValue.total = null;
      }
    },
    calculateMultiplier() {
      if (this.formValue.total && this.formValue.price) {
        let extra = this.formValue.total - parseFloat(this.formValue.price);
        this.formValue.multiplier = (
          (extra / parseFloat(this.formValue.price)) *
          100
        ).toFixed(4);
      } else {
        this.formValue.multiplier = null;
      }
    },
    searchDriverByPhone() {
      this.formValue.driver_code = null;

      if (this.formValue.mobile && this.formValue.mobile.length == 11) {
        let url = `v1/users/search?field=mobile&return=mobile,name,user_code&key=${this.formValue.mobile}`;
        userService
          .get(url)
          .then((response) => {
            let drivers = response.data.data;

            if (drivers && drivers.length > 0) {
              this.formValue.driver_code = drivers[0].user_code;
              this.formValue.name = drivers[0].name;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    assignDriver() {
      this.isLoading = true;
      http
        .post('v2/partners/backup/request/direct/assign', this.formValue)
        .then((response) => {
          this.isLoading = false;
          this.$swal({
            icon: 'success',
            text: response.data.message
          });
          this.$refs.modalCloseBtn.click();
          this.setFormValues();
          this.$emit('refreshData');
        })
        .catch((error) => {
          this.isLoading = false;
          console.log(error.response);
          this.$swal({
            icon: 'error',
            text: error.response.data.message
          });
        });
    }
  }
};
</script>

<style scoped>
.invite-backup-partner-table {
  box-shadow: 0px 2px 6px 4px rgba(0, 0, 0, 0.07);
  padding: 12px;
  border-radius: 4px;
  margin: 5px 0;
}
table {
  margin-bottom: 0;
}
tbody tr:last-child td {
  border-bottom: none;
}
.danger-value {
  background: rgba(255, 0, 0, 0.6);
}
</style>
